





















import {Vue, Prop, Component} from 'vue-property-decorator'
import {getPersianDate} from "@/util/utils";
import { DateBaseOnCurrentTimeConverter } from '@/util/dateConverter';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';
import {GroupedLetterOwnersByCompanyDto} from '@/store/models/LetterOwner/GroupedLetterOwnersByCompanyDto'
import store from '@/store';

@Component
export default class GroupedByCompanyOwner extends Vue{
    @Prop() groupData?: GroupedLetterOwnersByCompanyDto
    shallShowOwners = false;
    

    toggleShowOwners(){
        this.shallShowOwners = !this.shallShowOwners;
    }

    selectOwner(ownerName: string, companyName: string, ownerId: string){
        
        const obj = {} as any;
        obj.ownerName = ownerName;
        obj.companyName = companyName;
        obj.ownerId = ownerId;
        this.$emit("owner-selected", obj);
    }
    
}



